import React from 'react'

export default function OptionalTag() {

  const optionalTagStyles = {
    backgroundColor: "#A9A9A9",
    color: "white",
    padding: "0.06rem 0.25rem",
    borderRadius: "0.3rem",
    fontSize: "0.6rem",
    textAlign: "center",
    marginLeft: "0.2rem"
  } 

  return (
    <span style={ optionalTagStyles }>Optional</span>
  )
}
